export default __webpack_public_path__ + "static/media/admin-dashboard.f627bea1.PNG";